export const loginRequest = {
  scopes: ["openid", "profile", "email", "offline_access", "https://www.wvd.microsoft.com/.default"],
  prompt: 'select_account'
};